var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { IconMapPin } from "@wrstudios/icons";
import { Container, MapImage, PinContainer } from "./styled/listing-map-static";
var MAPBOX_STATIC_API_MAXIMUM_WIDTH = 1280;

function ListingMapStatic(_a) {
  var mapboxApiToken = _a.mapboxApiToken,
      latitude = _a.latitude,
      longitude = _a.longitude,
      _b = _a.zoomLevel,
      zoomLevel = _b === void 0 ? 15 : _b,
      _c = _a.bearing,
      bearing = _c === void 0 ? 0 : _c,
      _d = _a.pitch,
      pitch = _d === void 0 ? 0 : _d,
      _e = _a.logo,
      logo = _e === void 0 ? false : _e,
      _f = _a.attribution,
      attribution = _f === void 0 ? false : _f,
      _g = _a.width,
      width = _g === void 0 ? 300 : _g,
      _h = _a.height,
      height = _h === void 0 ? 200 : _h,
      _j = _a.pin,
      pin = _j === void 0 ? React.createElement(IconMapPin, null) : _j,
      _k = _a.mapStyle,
      mapStyle = _k === void 0 ? "streets-v11" : _k,
      onClick = _a.onClick,
      props = __rest(_a, ["mapboxApiToken", "latitude", "longitude", "zoomLevel", "bearing", "pitch", "logo", "attribution", "width", "height", "pin", "mapStyle", "onClick"]);

  var finalWidth = Math.round(width) > MAPBOX_STATIC_API_MAXIMUM_WIDTH ? MAPBOX_STATIC_API_MAXIMUM_WIDTH : Math.round(width);
  return React.createElement(Container, __assign({
    onClick: onClick
  }, props), React.createElement(MapImage, {
    src: "https://api.mapbox.com/styles/v1/mapbox/" + mapStyle + "/static/" + longitude + "," + latitude + "," + zoomLevel + "," + bearing + "," + pitch + "/" + finalWidth + "x" + height + "@2x?access_token=" + mapboxApiToken + "&logo=" + logo + "&attribution=" + attribution,
    alt: "Location at latitude " + latitude + " and longitude " + longitude
  }), React.createElement(PinContainer, null, pin));
}

export default ListingMapStatic;